import React from "react";
import Select from "react-select";
import {
  Row,
  Col,
  Label
} from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";


const fontWeights = [
  { value: "lighter", label: <SystemLabel name="Lighter" /> },
  { value: "normal", label: <SystemLabel name="Normal" /> },
  { value: "bold", label: <SystemLabel name="Bold" />},
  { value: "bolder", label: <SystemLabel name="Bolder" />}
];

export const FontWeightPicker = ({ weight, onChange, currentFont, path }) => {
    const customStyles = {
        control: (provided, state) => ({
          ...provided,
      
          backgroundColor: "#50525d",
          color: "#eee",
          border: "0px",
          maxWidth: "calc(100% - 48px)%",
          width: 272,
        }),
        noOptionsMessage: (provided, state) => ({
          ...provided,
          color: "green",
          maxWidth: "100%",
        }),
        input: (provided, state) => ({
          ...provided,
          color: "#eee",
          maxWidth: "100%",
        }),
        singleValue: (provided, state) => ({
          ...provided,
          color: "#eee",
        }),
        indicatorSeparator: (provided, state) => ({
          ...provided,
          background: "transparent",
        }),
        menu: (provided, state) => ({
          ...provided,
          backgroundColor: "#373842",
          maxWidth: "100%",
          zIndex: 100,
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#20a8d8" : "#3d3d3d",
          color: "#eee",
          ["&:hover"]: {
            backgroundColor: "#5a5959ba",
          },
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#eee",
        }),
      };

  return (
    <React.Fragment>
      <Row >
        <Col className="list-setting-item-title">
          <Label className="primary-text">
            <SystemLabel name="FontWeight" />
          </Label>
        </Col>
        <Col className="list-setting-item-item">
          <Select
            className="jirango-weightpicker"
            classNamePrefix="jirango-weightpicker"
            options={fontWeights}
            value={{
              value: weight !== undefined ? weight : 'unset',
              label: weight !== undefined ? weight.charAt(0).toUpperCase() + weight.slice(1) : 'Unset'
            }}
            onChange={selectedOption =>
              onChange(null, selectedOption.value, path)
            }
            styles={customStyles}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
